
import React, { Component, PropTypes } from 'react';

import Link from 'components/Link';
import UserAvatar from 'components/UserAvatar';
import './style.scss';

class ArticleMeta extends Component {

  renderCategories(categories) {
    return categories.map((category, index) => {
      return (
        <span key={category.name}>
          <strong>
            <Link to={category.url}>{category.name}</Link>
          </strong>
          {index < categories.length - 1 ? ', ' : ''}
        </span>
      );
    });
  }

  render() {
    return (
      <div className="article-meta">
        <div className="avatar">
          <UserAvatar imageUrl={this.props.authorAvatarUrl} letter={this.props.authorName[0]} />
        </div>

        <div className="meta">
          <span className="author">
            <strong>{this.props.authorName}</strong>
            <span> {__('members.magazine.articleAuthorCategoriesSeparator')} {this.renderCategories(this.props.categories)} </span>
          </span>

          <span className="time">{this.props.createdAt}</span>

          {this.props.showsComments &&
            <span className="comment-count">
              <Link to={`${this.props.articleUrl}#comments`}>{this.props.commentsInfo}</Link>
            </span>
          }
        </div>
      </div>
    );
  }
}

ArticleMeta.propTypes = {
  authorAvatarUrl: PropTypes.string,
  authorName: PropTypes.string,
  categories: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    url: PropTypes.string
  })),
  commentsInfo: PropTypes.string,
  createdAt: PropTypes.string,
  showsComments: PropTypes.bool,
  articleUrl: PropTypes.string
};

export default ArticleMeta;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/ArticleOuter/Article/ArticlePreview/ArticleMeta/index.js
 **/